"use client";
import Images, { Icons } from "../assets/assets";
import Navigation from "@/HomeFeatures/Navigation";
import PrimaryBtn from "@/components/PrimaryBtn";
import Resources from "./press-release";
import Cta from "@/HomeFeatures/Cta";
import { useTheme } from "@/HomeFeatures/Context/ThemeContext";
import Image from "next/image";

export default function WhitePaperClient() {
  const { handleOpenQuote } = useTheme();
  return (
    <>
      <section className="relative w-full h-[max-content] overflow-hidden">
        <div className="absolute inset-0 ">
          <Image
            src={Images?.resourcebg}
            alt="project communication strategy"
            fill
            sizes="(max-width: 768px) 100vw, (max-width: 1536px) 50vw, 700px"
            quality={65}
            className="object-cover z-0"
            priority
            fetchPriority="high"
          />
        </div>

        <div className="absolute inset-0 bg-black/50 z-[1]" />

        <div className="relative z-10 w-full flex flex-col pb-[100px]">
          <Navigation />

          <h1
            className="pt-[75px] mx-auto text-center max-w-[18ch] text-white 
      text-[length:var(--service-banner-title)] font-normal 
      clash-font capitalize leading-[100%]"
          >
            We’ve covered the, <br /> international press
          </h1>

          <p
            className="text-white/50 mx-auto text-[length:var(--banner-para)] 
      max-w-[90%] lg:max-w-[60ch] text-center font-normal 
      leading-[150%] tracking-tight py-4"
          >
            Stay up to date with all the latest Project Releases, Service
            Offerings, Interviews, Company Rankings & Events.
          </p>

          <PrimaryBtn
            styleClass="mx-auto"
            text="Let’s Discuss your Idea"
            iconSrc={Icons?.chevronBlue}
            href={`${process.env.NEXT_PUBLIC_BASE_URL}/contact-us`}
          />
        </div>
      </section>
      <Resources />
      <Cta
        title1={
          <>
            <span className="text-[#fff]">Need a proposal?</span> <br></br>
          </>
        }
        title2={
          <span className="text-[#fff]">Let&apos;s discuss the project!</span>
        }
        description={
          <span className="text-[#fff]">
            Get in touch with us and discuss the needs and requirements of your
            project.
          </span>
        }
        button={
          <PrimaryBtn
            text="Request a Quote"
            iconSrc={Icons?.chevronBlue}
            dark={true}
            onClick={() => {
              handleOpenQuote();
            }}
          />
        }
        bgImage={Images?.serviceCtaBg}
        animationShade="bg-gradient-to-t from-[#0C41B2] via-[#0C41B2]/70 to-transparent"
        circleColor="border-[rgba(255,255,255,0.2)]"
      />
    </>
  );
}
